import React, { useEffect, useState } from 'react';
import Logo from '../../Common/Assets/Images/logo.png';
import { useNavigate } from 'react-router-dom';
import topBg from '../../Common/Assets/Images/top-bg.png';
import BottumBg from '../../Common/Assets/Images/bottum-bg.png';
import middelBg from '../../Common/Assets/Images/middel-star-bg.png';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { LIFESTYLE_LOOKING_DATA } from '../../ContextManager/constants';
import {
  doc,
  getDoc,
  getFirestore,
  collection,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import app from '../../Utils/firebaseService';
import { Modal } from 'react-bootstrap';

const SelectLifeStyleLooking = () => {
  const { t } = useTranslation();
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const linkId = new URLSearchParams(window.location.search).get('id');
  const sid = new URLSearchParams(window.location.search).get('sid');

  const [lifestyle_looking_options, setLifestyleLookingOptions] = useState([]);

  const religiousViewData = [
    { english: 'Modern-orthodox', hebrew: 'דתי בראש טוב' },
    { english: 'Orthodox', hebrew: 'דתי-לאומי' },
    { english: 'Ultra-orthodox', hebrew: 'דתי-תורני' },
    { english: 'Traditional', hebrew: 'מסורתי' },
    { english: 'Secular', hebrew: 'חילוני' },
    { english: 'Ex-religious', hebrew: 'דתל״ש' },
  ];

  const [show, setShow] = useState(false);

  const firestore = getFirestore(app);

  // show height counting on ui in this side

  useEffect(() => {
    window.scrollTo(0, 100);

    if (sid != null && sid != '') {
      getData();
    }

    document.body.style.setProperty('', '', '');
    document.body.style.overscrollBehaviorY = 'contain';

    return () => {
      document.body.style.setProperty('', '', '');
      document.body.style.overscrollBehaviorY = 'none';
    };
  }, []);

  const getData = async () => {
    // setShow(true);
    const docSnap = await getDoc(doc(firestore, 'singles', sid));

    if (docSnap.exists) {
      const lifestyle_looking = docSnap.get('lifestyle_looking');

      if (lifestyle_looking != null) {
        setLifestyleLookingOptions(lifestyle_looking);
      }
    }
    // setShow(false);
  };

  // Save data in firebase cloud this side

  const saveData = async () => {
    console.log('lifestyle_looking_options', lifestyle_looking_options);

    if (lifestyle_looking_options.length > 0) {
      dispatch({
        type: LIFESTYLE_LOOKING_DATA,
        payload: lifestyle_looking_options,
      });

      if (sid != null && sid != '') {
        await updateDoc(doc(collection(firestore, 'singles'), sid), {
          lifestyle_looking: lifestyle_looking_options,
          last_updated: serverTimestamp(),
        });
      }

      if (linkId != null && linkId != '') {
        Navigate(`/select-geography?id=${linkId}`);
      } else {
        Navigate(`/select-geography?sid=${sid}`);
      }
    }
  };

  return (
    <>
      {/* loading page */}
      <Modal show={show} className="model-loader">
        <div className="modal-dialog loading-page">
          <div className="modal-content loading-page">
            <div className="loader1 save-loader">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </Modal>

      <div
        className="main-home location occupation life_style second"
        style={{ height: window.innerHeight }}
      >
        <div className="universal-background-top">
          <img className="universal-background-top-img" src={topBg} alt="logo" />
        </div>
        <div className="container first-container">
          <div className="row">
            <div className="col-12 matchup-col matchup-col-select-height">
              <div className="logo-div">
                <img className="universal-logo logo-margine location" src={Logo} alt="" />
              </div>

              {/* <div className="border-line">
                <div></div>
                <div className="second"></div>
                <div className="third"></div>
                <div className="forth"></div>
              </div> */}

              <div className="line-indicator-box container-fluid">
                <div className="row">
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-fill"></div>
                  <div className="indicator-blank"></div>
                </div>
              </div>
              <div className="universal-background-middel-star">
                <img className="universal-background-middel-star-img" src={middelBg} alt="logo" />
              </div>
              <div className="logo-div ">
                <p className="text-1 gender-1-text location">
                  <b>{'איזה סגנונות אורח חיים לחפש לך?'}</b>
                </p>
              </div>
              <div className="style-content">
                <p>{'אפשר לבחור כמה'}</p>
              </div>

              <ul className="list-btn-data-box">
                {religiousViewData.map((item, index) => {
                  return (
                    <li
                      key={index}
                      id="list_item"
                      onClick={() => {
                        var dt = [...lifestyle_looking_options];
                        const ind = dt.indexOf(index);
                        if (ind > -1) {
                          dt.splice(ind, 1);
                        } else {
                          dt.push(index);
                        }
                        setLifestyleLookingOptions(dt);
                      }}
                      style={{
                        background:
                          lifestyle_looking_options.indexOf(index) > -1 ? '#EE2C46' : 'white',
                        color: lifestyle_looking_options.indexOf(index) > -1 ? 'white' : '#9A9A9A',
                        border:
                          lifestyle_looking_options.indexOf(index) > -1
                            ? '1px solid #EE2C46'
                            : '1px solid #D9D9D9',
                      }}
                    >
                      <a>{item['hebrew']}</a>
                    </li>
                  );
                })}
              </ul>

              <section className="location">
                <div className="container">
                  <div location-wrap></div>
                </div>
              </section>

              <div className="image-group1 location-btn">
                <div className="button-div btn-change">
                  <button
                    className="button-accept profile-button"
                    style={
                      lifestyle_looking_options.length > 0
                        ? { backgroundColor: '#EE2C46' }
                        : { backgroundColor: 'grey' }
                    }
                    onClick={saveData}
                  >
                    {t('choose-page-button')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="universal-background-bottom">
          <img className="universal-background-bottom-img" src={BottumBg} alt="logo" />
        </div>
      </div>
    </>
  );
};
export default SelectLifeStyleLooking;
